import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { FiMenu } from 'react-icons/fi';

function Navigation({ onMenuClick }) {
  const { authenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  console.log('Navigation render - authenticated:', authenticated, 'onMenuClick:', typeof onMenuClick);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleHamburgerClick = () => {
    console.log('Hamburger button clicked');
    if (onMenuClick) {
      onMenuClick();
    } else {
      console.error('onMenuClick is not defined!');
    }
  };

  return (
    <nav className={`navbar ${authenticated ? 'navbar-authenticated' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-left">
          {authenticated && (
            <button 
              className="navbar-hamburger" 
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleHamburgerClick(); }}
              aria-label="Toggle menu"
            >
              <FiMenu size={24} />
            </button>
          )}
          <Link to="/" className="navbar-brand">
            🐼 SharePanda
          </Link>
        </div>
        <ul className="navbar-nav">
          {authenticated ? (
            <>
              <li className="desktop-only">
                <Link to="/browse" className="nav-link">
                  Browse Projects
                </Link>
              </li>
              <li className="desktop-only">
                <Link to="/static-sites" className="nav-link">
                  Static Sites
                </Link>
              </li>
              <li className="desktop-only">
                <span className="nav-link" style={{ cursor: 'default' }}>
                  {user?.username}
                </span>
              </li>
              <li className="desktop-only">
                <button onClick={handleLogout} className="btn btn-secondary">
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to="/browse" className="nav-link">
                  Browse
                </Link>
              </li>
              <li>
                <Link to="/static-sites" className="nav-link">
                  Static Sites
                </Link>
              </li>
              <li>
                <Link to="/docs" className="nav-link">
                  API Docs
                </Link>
              </li>
              <li>
                <Link to="/login" className="btn btn-primary">
                  Login
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
